module.exports = __webpack_public_path__ + "img/sanat.5855205f.png";